import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import { Link } from 'react-router-dom';
import {
  UserTable,
  mountTable,
  unmountTable,
  refetchTable,
  deleteUser,
} from '@kineticdata/react';
import { generateEmptyBodyRow, Icon } from '@kineticdata/ui';
import { regSaga, regRoute } from '../../../store';
import { ActionsHeaderCell } from '../../common/tables/ActionsHeaderCell';
import { ControlGroup } from '../../common/ControlGroup';
import { userDeleteConfirmOptions } from './index';

const tableKey = slug => `${slug}-space-users-table`;

regRoute('SPACE_USERS_LIST_PAGE', '/spaces/edit/:spaceSlug/users');

regSaga(
  takeEvery('ENTER_SPACE_USERS_LIST_PAGE', function* ({ payload }) {
    yield call(mountTable, tableKey(payload.params.spaceSlug));
  }),
);
regSaga(
  takeEvery('LEAVE_SPACE_USERS_LIST_PAGE', function* ({ payload }) {
    yield call(unmountTable, tableKey(payload.params.spaceSlug));
  }),
);

const ActionsCell = ({ row, tableOptions: { spaceSlug } }) => (
  <td>
    <ControlGroup
      controlKey={row.get('username')}
      actions={{
        delete: username => deleteUser({ spaceSlug, username }),
      }}
      confirmations={{
        delete: userDeleteConfirmOptions,
      }}
      onSuccess={() => refetchTable(tableKey(spaceSlug))}
    >
      {({ actions, anyPending, pending }) => (
        <div className="btn-set">
          <Link
            to={`/spaces/edit/${spaceSlug}/users/edit/${row.get('username')}`}
            className="btn btn-table"
            aria-label="Edit"
            title="Edit"
          >
            <Icon name="edit-2" md />
          </Link>
          <button
            className="btn btn-table"
            type="button"
            disabled={anyPending}
            onClick={actions.delete(row.get('username'))}
            aria-label="Delete"
            title="Delete"
          >
            {pending.get('delete') ? (
              <Icon name="circle-notch" md spin />
            ) : (
              <Icon name="trash" md />
            )}
          </button>
        </div>
      )}
    </ControlGroup>
  </td>
);

export const SpaceEditUsersList = props => (
  <>
    <div className="heading heading-sm">
      <div className="btn-set ms-auto">
        <Link
          className="btn btn-outline-primary btn-sm"
          to={`/spaces/edit/${props.spaceSlug}/users/new`}
        >
          <Icon name="plus" md />
          <span>New User</span>
        </Link>
      </div>
    </div>
    <UserTable
      system
      spaceSlug={props.spaceSlug}
      tableKey={tableKey(props.spaceSlug)}
      columnSet={['username', 'email', 'enabled', '_actions']}
      addColumns={[
        {
          value: '_actions',
          title: '',
          sortable: false,
          components: {
            BodyCell: ActionsCell,
            HeaderCell: ActionsHeaderCell,
          },
        },
      ]}
      components={{
        EmptyBodyRow: generateEmptyBodyRow({
          loadingMessage: 'Loading Users...',
          noSearchResultsMessage:
            'No Users were found - please modify your search criteria',
          noItemsMessage: 'There are no Users to display.',
          noItemsLinkTo: `/spaces/edit/${props.spaceSlug}/users/new`,
          noItemsLinkToMessage: 'Add new User',
        }),
      }}
    >
      {({ pagination, table }) => (
        <div className="content-container">
          {table}
          {pagination}
        </div>
      )}
    </UserTable>
  </>
);
